import Clipboard from 'clipboard';

// Copy/Paste function for copy link
if ( document.querySelectorAll( '.copy-link' ) ) {
	const clipboard = new Clipboard( '.copy-link' );
	clipboard.on( 'success', e => {
		const { trigger } = e;
		trigger.classList.add( 'copied' );
		setTimeout( function () {
			trigger.classList.remove( 'copied' );
		}, 3600 );
	} );
}
